import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, switchMap } from 'rxjs/operators';
import {
  PlansService,
  GetFilteredPlansResponse,
  GetPlanResponse,
} from 'src/app/core/proto';
import {
  actionPlanGet,
  actionPlanGetFailure,
  actionPlanGetSuccess,
  actionPlansGet,
  actionPlansGetFailure,
  actionPlansGetSuccess,
} from 'src/app/core/store/plans/plans.actions';

@Injectable({
  providedIn: 'root',
})
export class PlansEffects {
  constructor(private plansService: PlansService, private actions$: Actions) {}

  getPlans$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actionPlansGet),
      switchMap((params) => {
        return this.plansService.getFilteredPlansInternal(params.body).pipe(
          map(
            (plansResponse: GetFilteredPlansResponse) => {
              return actionPlansGetSuccess({
                payload: plansResponse,
              });
            },
            catchError(() => of(actionPlansGetFailure()))
          )
        );
      })
    );
  });

  getPlan$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actionPlanGet),
      exhaustMap((action) => {
        if (action.params.planId) {
          return this.plansService.getPlan(action.params.planId).pipe(
            map((res: GetPlanResponse) => {
              return actionPlanGetSuccess({
                payload: res,
              });
            }),
            catchError(() => of(actionPlanGetFailure()))
          );
        }
      })
    );
  });
}
